
<template>
  <el-dialog
    class="linkDialog corpDialog"
    width="500px"
    title="权限管理"
    :visible.sync="visible"
    @close="dialogClose"
  >
    <div class="box">
      <ul v-if="userList.length">
        <li v-for="(item,index) in userList" :key="index">
          <img :src="item.picture" alt />
          <span>{{item.userName}}</span>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogClose">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import http from "../utils/http";
import { MSG } from "../utils/utils";
export default {
  name: "roleControl",
  data() {
    return {
      interface: {
        searchUser: `/admin/list`
      },
      visible: false,
      userList: []
    };
  },
  props: ["dialogShow"],
  watch: {
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  mounted() {
    this.handleSearchUser();
  },
  methods: {
    handleCloseCoopDialog(item, index) {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    handleSearchUser() {
      http
        .get(this.interface.searchUser)
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.userList = data || [];
          } else {
            MSG.error(message);
          }
        })
        .catch(error => {
          MSG.error(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.corpDialog .el-form-item__content {
  width: 100%;
}
.corpDialog .addCoop-btn {
  width: 60px;
  height: 40px;
  background-color: #ff552e;
  color: #fff;
  font-size: 25px;
  text-align: center;
  line-height: 14px;
}
.box {
  height: 180px;
  overflow-y: scroll;
  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px;
    li {
      width: 50%;
      border-bottom: 1px solid #666;
      border-right: 1px solid #666;
      height: 50px;
      line-height: 50px;
      padding: 10px;
      img {
        border-radius: 50%;
        width: 30px;
        height: 30px;
      }
      span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        position: relative;
        bottom: 10px;
        left: 10px;
      }
      &:nth-child(odd) {
        border-left: 1px solid #666;
      }
      &:nth-child(1),
      &:nth-child(2) {
        border-top: 1px solid #666;
      }
    }
  }
}
</style>



  


// WEBPACK FOOTER //
// src/components/roleControl.vue